module.exports = __webpack_public_path__ + "assets/img/18_1819.af9b7e35.jpg";